import keyBy from 'lodash/keyBy';
import mapValues from 'lodash/mapValues';

export const getCountryOptions = edges => mapValues(
  keyBy(edges, 'node.id'),
  'node.displayName',
);

export const STATE_LIST = [
  { code: 'AL', label: 'Alabama' },
  { code: 'AK', label: 'Alaska' },
  { code: 'AZ', label: 'Arizona' },
  { code: 'AR', label: 'Arkansas' },
  { code: 'CA', label: 'California' },
  { code: 'CO', label: 'Colorado' },
  { code: 'CT', label: 'Connecticut' },
  { code: 'DE', label: 'Delaware' },
  { code: 'DC', label: 'District of Columbia' },
  { code: 'FL', label: 'Florida' },
  { code: 'GA', label: 'Georgia' },
  { code: 'HI', label: 'Hawaii' },
  { code: 'ID', label: 'Idaho' },
  { code: 'IL', label: 'Illinois' },
  { code: 'IN', label: 'Indiana' },
  { code: 'IA', label: 'Iowa' },
  { code: 'KS', label: 'Kansas' },
  { code: 'KY', label: 'Kentucky' },
  { code: 'LA', label: 'Louisiana' },
  { code: 'ME', label: 'Maine' },
  { code: 'MD', label: 'Maryland' },
  { code: 'MA', label: 'Massachusetts' },
  { code: 'MI', label: 'Michigan' },
  { code: 'MN', label: 'Minnesota' },
  { code: 'MS', label: 'Mississippi' },
  { code: 'MO', label: 'Missouri' },
  { code: 'MT', label: 'Montana' },
  { code: 'NE', label: 'Nebraska' },
  { code: 'NV', label: 'Nevada' },
  { code: 'NH', label: 'New Hampshire' },
  { code: 'NJ', label: 'New Jersey' },
  { code: 'NM', label: 'New Mexico' },
  { code: 'NY', label: 'New York' },
  { code: 'NC', label: 'North Carolina' },
  { code: 'ND', label: 'North Dakota' },
  { code: 'OH', label: 'Ohio' },
  { code: 'OK', label: 'Oklahoma' },
  { code: 'OR', label: 'Oregon' },
  { code: 'PA', label: 'Pennsylvania' },
  { code: 'RI', label: 'Rhode Island' },
  { code: 'SC', label: 'South Carolina' },
  { code: 'SD', label: 'South Dakota' },
  { code: 'TN', label: 'Tennessee' },
  { code: 'TX', label: 'Texas' },
  { code: 'UT', label: 'Utah' },
  { code: 'VT', label: 'Vermont' },
  { code: 'VA', label: 'Virginia' },
  { code: 'WA', label: 'Washington' },
  { code: 'WV', label: 'West Virginia' },
  { code: 'WI', label: 'Wisconsin' },
  { code: 'WY', label: 'Wyoming' },
];

export const parseFootNotes = (notes = '') => {
  const CODES_DB = {
    'A#': 'Corrected ZIP Code',
    'B#': 'Corrected city/state spelling',
    'C#': 'Invalid city/state/ZIP',
    'D#': 'No ZIP+4 assigned',
    'E#': 'Same ZIP for multiple',
    'F#': 'Address not found',
    'G#': 'Used addressee data',
    'H#': 'Missing secondary number',
    'I#': 'Insufficient/ incorrect address data',
    'J#': 'Dual address',
    'K#': 'Cardinal rule match',
    'L#': 'Changed address component',
    'LL#': 'Flagged address for LACSLink',
    'LI#': 'Flagged address for LACSLink',
    'M#': 'Corrected street spelling',
    'N#': 'Fixed abbreviations',
    'O#': 'Multiple ZIP+4; lowest used',
    'P#': 'Better address exists',
    'Q#': 'Unique ZIP match',
    'R#': 'No match; EWS: Match soon',
    'S#': 'Unrecognized secondary address',
    'T#': 'Multiple response due to magnet street syndrome',
    'U#': 'Unofficial city name',
    'V#': 'Unverifiable city/state',
    'W#': 'Invalid delivery address',
    'X#': 'Unique ZIP Code',
    'Y#': 'Military match',
    'Z#': 'Matched with ZIPMOVE',
  };
  const codes = notes.split('#');
  const output = [];

  for (let i = 0; i < codes.length; i += 1) {
    if (codes[i]) {
      output.push(CODES_DB[`${codes[i]}#`]);
    }
  }

  return output;
};

export const startCase = (str = '') => {
  let result = '';
  if (str) {
    const subs = str.split(' ');
    result = subs.map((s) => {
      if (s) {
        return `${s[0].toUpperCase()}${s.substring(1).toLowerCase()}`;
      }
      return '';
    }).join(' ');
  }
  return result;
};
